import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "autosizingreferenceenum"
    }}>{`AutoSizingReferenceEnum`}</h1>
    <p>{`Auto sizing reference points for text.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_LEFT_POINT`}</strong>{` = 1953459301`}</p>
      <p parentName="blockquote">{`Top left point of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_CENTER_POINT`}</strong>{` = 1953456997`}</p>
      <p parentName="blockquote">{`Center point on the top edge of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_RIGHT_POINT`}</strong>{` = 1953460841`}</p>
      <p parentName="blockquote">{`Top right point of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_CENTER_POINT`}</strong>{` = 1818583909`}</p>
      <p parentName="blockquote">{`Center point on the left edge of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTER_POINT`}</strong>{` = 1668183154`}</p>
      <p parentName="blockquote">{`Center point of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_CENTER_POINT`}</strong>{` = 1919509349`}</p>
      <p parentName="blockquote">{`Center point on the right edge of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOTTOM_LEFT_POINT`}</strong>{` = 1651469413`}</p>
      <p parentName="blockquote">{`Bottom left point of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOTTOM_CENTER_POINT`}</strong>{` = 1651467109`}</p>
      <p parentName="blockquote">{`Center point on the botom edge of bounding box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOTTOM_RIGHT_POINT`}</strong>{` = 1651470953`}</p>
      <p parentName="blockquote">{`Bottom right point of bounding box`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      